/**
 * Dependencies.
 */
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import PackageModel from '@/api/package/package.model';
import configuration from '@/plugins/configuration.plugin';

/**
 * Component.
 */
@Component({
  name: 'confirm-day-component'
})
export default class extends Vue {
  /**
   * Property `minimumExpirationDays`.
   */
  minimumExpirationDays = 4;

  /**
   * Property `nearExpiringDate`.
   */
  nearExpiringDate = null;

  /**
   * Property `newDate`.
   */
  @Prop()
  newDate: string;

  /**
   * Property `packages`.
   */
  @Prop({ default: () => [] })
  packages: PackageModel[];

  /**
   * Getter `key`.
   */
  get key() {
    const { key = null } = this.$route.params || {};

    return key;
  }

  /**
   * Getter `hasDeliveryProductsExpiring`.
   */
  get hasDeliveryProductsExpiring() {
    const packages = this.packages ? [...this.packages] : [];
    const newDate = this.$moment(this.newDate).startOf('day');

    this.nearExpiringDate = null;

    let hasLimitedDateProducts = false;

    packages.every(box => {
      const { items: products = [] } = box || {};

      products.every(({ expirationDate }) => {
        if (expirationDate) {
          const expiration = this.$moment(expirationDate).startOf('day');

          if (expiration.isValid() && newDate.isValid()) {
            const daysToExpiration: number =
              this.$moment
                .duration(expiration.subtract(1, 'days').diff(newDate))
                .asDays() || 0;

            if (daysToExpiration <= this.minimumExpirationDays) {
              hasLimitedDateProducts = true;
              this.nearExpiringDate = expirationDate;
            }
          }
        }

        return !hasLimitedDateProducts;
      });

      return !hasLimitedDateProducts;
    });

    return hasLimitedDateProducts;
  }

  /**
   * Lifecycle created hook.
   */
  created() {
    this.handleGetConfiguration();
  }

  /**
   * Handle get configuration.
   */
  async handleGetConfiguration() {
    const config = await configuration.getMinimumProductExpiration();
    const { minimumProductExpiration = null } = config || {};

    if (minimumProductExpiration) {
      this.minimumExpirationDays = minimumProductExpiration;
    }
  }

  /**
   * Handle change address.
   */
  handleChangeAddress() {
    this.$router.push({
      name: 'SearchAddress',
      params: {
        key: this.key
      }
    });
  }
}
